module.exports = __webpack_public_path__ + "@/assets/img/practica-profesionalizante.cc6ce4d5.svg";